import React from "react";
import { ChevronDown } from "lucide-react";
import RecordingExpandedCard from "./RecordingExpandedCard";


const getInitialName = (first, last) => {
  if (!first || !last) return "";
  return `${first[0]}. ${last}`;
};

const renderStatusBadge = (status) => (
  <span
    className={`status-badge ${status.toLowerCase()}`}
    title={`Recording status: ${status}`}
    tabIndex={0}
  >
    {status}
  </span>
);

const RecordingRow = ({
  rec,
  expandedRow,
  setExpandedRow,
  transcriptToggles,
  setTranscriptToggles,
  fetchAudioBlobUrl,
  audioUrls,
  labelUpdateKey,
  updateSpeakerLabel,
  handleDeleteRecording
}) => {
  const isExpanded = expandedRow === rec.id;
  const toggleRow = () => {
    const newRow = isExpanded ? null : rec.id;
    setExpandedRow(newRow);
    if (newRow && !audioUrls[rec.recording_id]) {
      fetchAudioBlobUrl(rec.recording_id);
    }
  };
  return (
    <>
      <tr className="recording-row" onClick={toggleRow}>
        <td>{getInitialName(rec.user?.first_name, rec.user?.last_name)}</td>
        <td>{rec.user?.organization?.name || "N/A"}</td>
        <td>
          <span className="status-star-flex">
            {renderStatusBadge(rec.status)}
            {rec.is_starred && (
              <span
                className="star-icon"
                title="Starred for manager review"
                aria-label="starred"
                tabIndex={0}
              >★</span>
            )}
          </span>
        </td>
        <td className="arrow-cell">
          <ChevronDown className={`chevron-icon ${isExpanded ? 'expanded' : ''}`} />
        </td>
      </tr>
      {isExpanded && (
        <RecordingExpandedCard
          rec={rec}
          labelUpdateKey={labelUpdateKey}
          transcriptToggles={transcriptToggles}
          setTranscriptToggles={setTranscriptToggles}
          audioUrl={audioUrls[rec.recording_id]}
          updateSpeakerLabel={updateSpeakerLabel}
          handleDeleteRecording={handleDeleteRecording}
        />
      )}
    </>
  );
};

export default RecordingRow;
